import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../../translation/namespace';
import FormsRow from '../../../../components/molecules/Form/components/FormsRow/FormsRow';
import FormCheckbox from '../../../../components/molecules/Form/components/FormCheckbox/FormCheckbox';
import { useFormContext } from '../../../../components/molecules/Form';
import {
  ImagePreview,
  ImageUpload,
  ImageUploadDescription,
  ImageUploadParams,
  PreviewSuspense,
  PreviewWithCropper,
  useSingleImageUpload,
} from '../../../../_lib/components/ImageUpload';
import { TopHeadlineImage, TopHeadlineImageSmall } from '../../../../types/api/ImageType';
import { isValid } from '../../../../_lib/FileUpload/utils/validateImage';

type TeaserImageProps = {
  initialImage: TopHeadlineImage | TopHeadlineImageSmall | undefined;
};
const idSuffix = 'topheadline';
export default function TeaserImage({ initialImage }: TeaserImageProps) {
  const { inputs } = useFormContext();
  const { inputProps, labelProps, selectedPreview, suspendPreviewProps, imageUploadParamsProps, constraints } =
    useSingleImageUpload(idSuffix);
  const { t } = useTranslation(Namespace.TopHeadlinesForm);
  const { largeIfFirst } = inputs;

  return (
    <>
      <ImageUploadDescription constraints={constraints} />
      <ImageUpload inputProps={inputProps} labelProps={labelProps}>
        <PreviewSuspense {...suspendPreviewProps}>
          {isValid(selectedPreview)
            ? (
                <PreviewWithCropper selectedPreview={selectedPreview} />
              )
            : (
                <ImagePreview image={initialImage} responsiveType="topHeadlineImage" />
              )}
        </PreviewSuspense>
        <ImageUploadParams {...imageUploadParamsProps} hasInitialImage={!!initialImage} />
      </ImageUpload>
      <FormsRow>
        <FormCheckbox
          labelTitle={t('largeIfFirst')}
          id={`${largeIfFirst.name}-${idSuffix}`}
          layout="switch"
          name={largeIfFirst.name}
          checked={largeIfFirst.checked}
          value={largeIfFirst.value}
          onChange={largeIfFirst.onChange as any}
        />
      </FormsRow>
    </>
  );
}
